// extracted by mini-css-extract-plugin
module.exports = {"bannerImageContainer":"SurveyPage_bannerImageContainer__22Nn2","bannerImage":"SurveyPage_bannerImage__2nZzA"};